// Module
var code = `<h1 class="heading"></h1> `;
// Exports
export default code;